module.exports = __webpack_public_path__ + "img/c21236b0-7f11-11ea-962c-08002754c58b.c2d2a491.svg";